<template>
  <div class="social-media-links">
    <h3>Redes sociales</h3>
    <ul v-if="links && links.length">
      <li v-for="(link, index) in links" :key="index">
        <a :href="link.url" target="_blank" rel="noopener noreferrer">
          <img
            :src="getIconPath(link.type)"
            :alt="getPlatformName(link.type)"
            class="social-icon"
          />
        </a>
      </li>
    </ul>
    <p v-else>No hay redes sociales disponibles.</p>
  </div>
</template>

<script setup>
const props = defineProps({
  links: {
    type: Array,
    default: () => []
  }
});

const getPlatformName = type => {
  switch (type) {
    case 0:
      return "Website";
    case 1:
      return "Facebook";
    case 2:
      return "Spotify";
    case 3:
      return "Twitter";
    case 4:
      return "Instagram";
    case 5:
      return "Bandcamp";
    case 6:
      return "YouTube";
    case 7:
      return "SoundCloud";
    case 8:
      return "TikTok";
    case 125:
      return "Otro";
    default:
      return "Enlace";
  }
};

// Mapea el tipo de red social al path del icono
const getIconPath = type => {
  switch (type) {
    case 0: // website
      return require("@/assets/images/ic-web-topaz.svg");
    case 1: // Facebook
      return require("@/assets/images/ic-facebook-topaz.svg");
    case 2: // Spotify
      return require("@/assets/images/ic-spotify-topaz.svg");
    case 3: // Twitter
      return require("@/assets/images/ic-twitter-topaz.svg");
    case 4: // Instagram
      return require("@/assets/images/ic-instagram-topaz.svg");
    case 5: // Bandcamp
      return require("@/assets/images/ic-bandcamp-topaz.svg");
    case 6: // YouTube
      return require("@/assets/images/ic-youtube-topaz.svg");
    case 7: // SoundCloud
      return require("@/assets/images/ic-sound-cloud-topaz.svg");
    case 8: // TikTok
      return require("@/assets/images/ic-tiktok-topaz.svg");
    case 125: // Otro
      return require("@/assets/images/ic-web-topaz.svg");
    default:
      return require("@/assets/images/ic-web-topaz.svg");
  }
};
</script>

<style scoped>
.social-media-links h3 {
  text-align: left;
  font-style: bold;
  font-size: 20px;
}
.social-media-links {
  text-align: center;
  max-width: 90%;
}

.social-media-links ul {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.social-media-links li {
  margin: 10px 15px;
}

.social-media-links a {
  text-decoration: none;
  color: inherit;
  font-size: 16px;
  transition: color 0.3s ease, transform 0.2s ease;
}

.social-media-links a:hover {
  color: #2effec;
  transform: scale(1.1);
}

.social-media-links i {
  margin-right: 8px;
  font-size: 18px;
}
</style>
